<template>
  <section class="check-user">
    <initial-user-data-form/>
  </section>
</template>

<script>
import InitialUserDataForm from '../../forms/InitialUserDataForm';

export default {
  name: 'CheckUser',
  components: { InitialUserDataForm },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },

};
</script>

<style scoped>
</style>
